var View = require('views/base/view');
var Utils = require('lib/utils');

module.exports = View.extend({
  autoRender: true,
  className: 'header',
  tagName: 'header',
  template: require('./templates/header'),

  initialize: function() {
    this.docLink = {product:'NFIS',vintage:'2014',paragraph:'8695',memento:'MF'};
  },

  events: {
    'click #btnApropos': 'afficheApropos'
  },

  getTemplateData: function() {
    return {
      titreSimul: 'Loi Madelin',
      eflDocLink: Utils.eflLink(this.docLink),
      eflDocLbl: 'Mémento Fiscal N° 8695 S.'
    };
  },

  afterRender: function() {
    var target = this.$('meta[name=keywords]').attr('content');
    if (target !== 'efl') {
      this.$('#docLink').hide();
    }
    this.$('#titleMadelin').popover({
      html: true,
      placement: 'bottom',
      container: '#titleContainer',
      content: 'Les contrats « loi Madelin » permettent aux indépendants non agricoles ' +
      'de se constituer une retraite ou des garanties prévoyance complémentaires.<br/>' +
      'Les cotisations versées au titre des contrats sont déductibles des revenus professionnels, ' +
      'cette déductibilité fiscale des primes représente un avantage ' +
      'qui est fonction du taux marginal d’imposition.'
    });
  },

  afficheApropos: function(evt) {
    console.log('+++++ header-view.js : afficheAssistance +++++');
    evt.preventDefault();
    this.$('#modalApropos').modal({
      backdrop:'static',
      show: true
    });
  }
});
